"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getMember: ()=>getMember,
    createMemberPassword: ()=>createMemberPassword,
    loginByPhoneNumber: ()=>loginByPhoneNumber,
    validatePin: ()=>validatePin,
    createMembers: ()=>createMembers,
    updateMember: ()=>updateMember,
    checkAuth: ()=>checkAuth,
    logoutAuth: ()=>logoutAuth,
    encodeOrigin: ()=>encodeOrigin,
    authPin: ()=>authPin,
    updatePhoneRequest: ()=>updatePhoneRequest,
    updatePhoneCheckPin: ()=>updatePhoneCheckPin,
    requestPin: ()=>requestPin,
    syncFbToken: ()=>syncFbToken,
    deleteAccount: ()=>deleteAccount,
    useCheckAuth: ()=>useCheckAuth,
    useLogOut: ()=>useLogOut,
    useAuthPin: ()=>useAuthPin,
    useUpdatePhoneRequest: ()=>useUpdatePhoneRequest,
    useUpdatePhoneCheckPin: ()=>useUpdatePhoneCheckPin,
    useRequestPin: ()=>useRequestPin,
    useGetMember: ()=>useGetMember,
    useLoginByPhoneNumber: ()=>useLoginByPhoneNumber,
    useCreateMemberPassword: ()=>useCreateMemberPassword,
    useGetMemberPin: ()=>useGetMemberPin,
    useCreateMembers: ()=>useCreateMembers,
    useUpdateMember: ()=>useUpdateMember,
    useSyncFbToken: ()=>useSyncFbToken,
    useDeleteAccount: ()=>useDeleteAccount,
    patchAcknowledgeNotification: ()=>patchAcknowledgeNotification,
    useAcknowledgeNotification: ()=>useAcknowledgeNotification,
    useUpdatePreferredSendingMethod: ()=>useUpdatePreferredSendingMethod,
    updatePreferredSendingMethod: ()=>updatePreferredSendingMethod
});
const _reactQuery = require("react-query");
const _ = require("../..");
_exportStar(require("./profile"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
const getMember = async (payload, opts)=>{
    const response = await _.api.get(`/wallet/v1/members/${payload.walletId}`, opts);
    return response.member;
};
const createMemberPassword = async (payload, opts)=>{
    const response = await _.api.put(`/wallet/v1/members/${payload.walletId}`, payload, opts);
    return response.member;
};
const loginByPhoneNumber = async (payload, opts)=>{
    return await _.api.post('/join/v1/member_access_codes', payload, opts);
};
const validatePin = async (payload, opts)=>{
    const { accessCode , memberAccessCodeId , firebase_token  } = payload;
    return await _.api.get(`/join/v1/member_access_codes/${memberAccessCodeId}?access_code=${accessCode}&firebase_token=${firebase_token}`, opts);
};
const createMembers = async (payload, opts)=>{
    const response = await _.api.post('/native_app/v1/members/', payload, opts);
    return response;
};
const updateMember = async ({ payload , firebaseToken , walletId  }, opts)=>{
    await _.api.patch('native_app/v2/members', {
        member: {
            ...payload.member,
            interest_list: payload.interest_list
        },
        signature: payload.signature,
        firebaseToken
    }, opts);
    return await getMember({
        walletId
    }, opts);
};
const checkAuth = async (payload, opts)=>{
    let body = {
        stashboard_or_member_key: payload.stashboardOrMemberKey,
        origin: encodeOrigin(window.location.origin),
        id: payload.stashboardOrMemberKey
    };
    if (payload.reference) {
        body[payload.reference] = 1;
    }
    if (payload.skip_tendlc) {
        body.skip_tendlc = payload.skip_tendlc;
    }
    if (payload.merger_wallet_id) {
        body.merger_wallet_id = payload.merger_wallet_id;
    }
    return await _.rememberMeApi.post('wallet/auth/v1/remember_me/authenticate', body, opts);
};
const logoutAuth = async ()=>{
    return await _.rememberMeApi.get('wallet/auth/v1/remember_me/logout/');
};
function encodeOrigin(origin) {
    return encodeURIComponent(origin);
}
const authPin = async (payload, opts)=>{
    return await _.rememberMeApi.put(`wallet/auth/v1/remember_me/${payload.stashboardOrMemberKey}?${payload.reference}=1`, {
        pin: payload.pin,
        birthday: payload.birthday,
        merger_wallet_id: payload.merger_wallet_id,
        origin: encodeOrigin(window.location.origin),
        passkey_successful: payload.passkey_successful
    }, opts);
};
const updatePhoneRequest = async (payload, opts)=>{
    return await _.api.put(`native_app/v2/update_phone_number/${payload.stashboardOrMemberKey}`, {
        phone_number: payload.phone_number
    }, opts);
};
const updatePhoneCheckPin = async (payload, opts)=>{
    return await _.api.put('native_app/v2/update_phone_number/check_pin', {
        phone_number: payload.phone_number,
        pin: payload.pin,
        id: payload.stashboardOrMemberKey
    }, opts);
};
const requestPin = async (payload, opts)=>{
    return await _.api.put(`wallet/auth/v1/send_pin/${payload.stashboardOrMemberKey}?${payload.reference}=1`, payload, opts);
};
const syncFbToken = async (payload, opts)=>{
    const response = await _.api.put('native_app/v1/push_notification_settings/sync', payload, opts);
    return response;
};
const deleteAccount = async (payload, opts)=>{
    const response = await _.api.post('native_app/v2/members/destroy', payload, opts);
    return response;
};
const useCheckAuth = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , setPhoneNumber , setWalletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>checkAuth(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                phoneNumber: data.phone_number
            });
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setPhoneNumber(data.phone_number);
            setMobileSubscriberId(data.mobile_subscriber);
            setWalletId(data.merchant_member_key);
        }
    });
};
const useLogOut = (queryOptions = {})=>{
    const { cleanState  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(()=>logoutAuth(), {
        ...queryOptions,
        onSuccess: ()=>{
            cleanState();
        }
    });
};
const useAuthPin = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , setPhoneNumber , setWalletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>authPin(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                phoneNumber: data.phone_number
            });
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setPhoneNumber(data.phone_number);
            setMobileSubscriberId(data.mobile_subscriber);
            setWalletId(data.merchant_member_key);
        }
    });
};
const useUpdatePhoneRequest = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updatePhoneRequest(payload), {
        ...queryOptions
    });
};
const useUpdatePhoneCheckPin = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updatePhoneCheckPin(payload), {
        ...queryOptions
    });
};
const useRequestPin = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>requestPin(payload), {
        ...queryOptions
    });
};
const useGetMember = (queryOptions = {})=>{
    const { walletId , setMember , firebaseToken  } = (0, _.useSpringBigStore)();
    const { merchantOrg  } = (0, _.useAppSettings)();
    const shouldFetch = walletId;
    return (0, _reactQuery.useQuery)('members', ({ signal  })=>shouldFetch ? getMember({
            walletId,
            firebaseToken
        }, {
            signal
        }) : Promise.resolve(null), {
        ...queryOptions,
        onSuccess: async (data)=>{
            if (data) {
                if ((0, _.isReact)()) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const theme_id = urlParams.get('theme_id');
                    if (theme_id) {
                        localStorage.setItem('theme_id', theme_id);
                    }
                }
                setMember(data);
            }
        }
    });
};
const useLoginByPhoneNumber = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMemberAccessCodeId , setPhoneNumber , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>loginByPhoneNumber({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data, variables)=>{
            setStore({
                phoneNumber: variables.phone_number
            });
            setPhoneNumber(variables.phone_number);
            setMemberAccessCodeId(data.member_access_code_id);
        }
    });
};
const useCreateMemberPassword = (queryOptions = {})=>{
    const { walletId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>createMemberPassword({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (response)=>{
            console.log(response);
        }
    });
};
const useGetMemberPin = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>validatePin({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setMobileSubscriberId(data.mobile_subscriber);
        }
    });
};
const useCreateMembers = (queryOptions = {})=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { merchantOrg  } = (0, _.useAppSettings)();
    const { setMember , setWalletId , setMerchantId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>createMembers({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: async (data)=>{
            if (data && data.member?.wallet_id) {
                if ((0, _.isReact)()) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const theme_id = urlParams?.get('theme_id');
                    if (theme_id) {
                        localStorage.setItem('theme_id', theme_id);
                    }
                }
                setMember(data.member);
                setWalletId(data.member.wallet_id);
                if (data?.member?.merchant_id) {
                    setMerchantId(data?.member?.merchant_id);
                }
            }
            queryClient.invalidateQueries('merchants');
        }
    });
};
const useUpdateMember = (queryOptions = {})=>{
    const { phoneNumber , member , firebaseToken , setMember , walletId  } = (0, _.useSpringBigStore)();
    const { merchantOrg  } = (0, _.useAppSettings)();
    return (0, _reactQuery.useMutation)((payload)=>updateMember({
            payload: {
                signature: payload.signature,
                interest_list: payload.interest_list,
                member: {
                    ...payload.member,
                    phone_number: phoneNumber,
                    merchant_id: member?.merchant_id
                }
            },
            walletId: walletId,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: async (data)=>{
            if (data) {
                if ((0, _.isReact)()) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const theme_id = urlParams.get('theme_id');
                    if (theme_id) {
                        localStorage.setItem('theme_id', theme_id);
                    }
                }
                setMember(data);
            }
        }
    });
};
const useSyncFbToken = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>syncFbToken(payload), queryOptions);
};
const useDeleteAccount = (queryOptions = {})=>{
    const { cleanState  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>deleteAccount(payload), {
        ...queryOptions,
        onSuccess: ()=>{
            cleanState();
        },
        onError: (data)=>{
            console.log(data, 'error');
        }
    });
};
const patchAcknowledgeNotification = async ({ notification_id , wallet_id  })=>{
    return _.api.patch(`/wallet/v1/members/${wallet_id}/notifications/${notification_id}/acknowledge`);
};
const useAcknowledgeNotification = (queryOptions = {})=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(({ notification_id  })=>patchAcknowledgeNotification({
            notification_id: notification_id,
            wallet_id: walletId
        }), queryOptions);
};
const useUpdatePreferredSendingMethod = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updatePreferredSendingMethod(payload), {
        ...queryOptions
    });
};
const updatePreferredSendingMethod = (payload, opts)=>{
    return _.api.put('native_app/v2/members/update_preferred_sending_methods', payload, opts);
};
